// Slugify a string
function slugify(str) {
  str = str.replace(/^\s+|\s+$/g, '');

  // Make the string lowercase
  str = str.toLowerCase();

  // Remove accents, swap ñ for n, etc
  var from = "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;";
  var to   = "AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------";
  for (var i=0, l=from.length ; i<l ; i++) {
    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  // Remove invalid chars
  str = str.replace(/[^a-z0-9 -]/g, '') 
  // Collapse whitespace and replace by -
  .replace(/\s+/g, '-') 
  // Collapse dashes
  .replace(/-+/g, '-'); 

  return str;
}

function ProductSwatches() {  
  var ss_all = $('.single-option-selector');
  
  const sizeVariant = document.body.classList.contains('size-variant');
  const colorVariant = document.body.classList.contains('color-variant');
  
  ss_all.each(function() {
    var ss = $(this);
    
    if((sizeVariant || colorVariant) && this.options.length > 1) {
      ss.hide();
      var sw = '<div class="hc-swatches" data-select-id="'+ss.attr('id')+'">';

      ss.children().each(function(index) {
        var v = $(this).attr('value');
        
        var optionIndex = parseInt(ss.data('option').replace('option', ''));
        
        let curVariant = productVariants.find(variant => { if (variant.options[optionIndex - 1] === v) return true; });
       
        var i = index;
        var selected = (v == ss.val())?'selected':'';
        sw += `<div class="variant-input ${curVariant.inventory_quantity <= 0 ? 'hc-soldout-option' : ''} ${colorVariant ? 'color-swatch' : 'size-swatch'} hc-swatch ${selected === 'selected' ? 'selected' : ''}"  ${`style='background-image: url(${curVariant.swatch_background !== "" ? curVariant.swatch_background : curVariant.featured_image.src})'`} data-index="${i}" data-value="${v}">
					<input id="hc-swatch--${i}--${slugify(v)}" type="radio" name="swatch" value="${v}" data-index="option${i}" data-value="${v}" ${selected === 'selected' ? 'checked' : ''}  style="display: none;" />
                    <label for="hc-swatch--${i}--${slugify(v)}" data-index="${i}" data-value="${v}" class="hc-swatch-inner">${$(this).attr('value')}</label>
					<div class="crossout"></div>
               </div>`;
      });
      sw += '</div>';

      ss.before(sw);
    }
  });

  $('.hc-swatch').on('click', function(e) {
    
    $('.hc-swatch').removeClass('selected');
    
  	$(this).addClass('selected');
    
    var index = $(this).attr('data-index');
    var v = $(this).attr('data-value');
    //console.log(v);

    var ss = $('select#' + $(this).parent().attr('data-select-id'));
    
    ss.val(v).trigger('change');

    console.log(ss.parent().siblings('label').text().toLowerCase());
    
    if(ss.parent().siblings('label').text().toLowerCase().includes('color')) {
      ss.parent().siblings('label').text(`Color: ${v.includes('-') ? v.split('-')[1] : v}`);
    }
    
    $('.swatch-btn.selected', $(this).parent()).removeClass('selected');
    $(this).addClass('selected');  
  });
}